import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { send_otp } from '../services';
import TermsService from '../Components/TermsServices';
import PrivacyPolicy from '../Components/PrivacyPolicy';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import useSsoDiscovery from './ssoAuth/useSsoDiscovery';
import AuthLayout, { trackPointer, Field, AlertCircleIcon, CheckCircleIcon, ArrowRightIcon, MailIcon, LockIcon, EyeButton } from './AuthLayout';
function UserIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
      <circle cx="12" cy="7" r="4"/>
    </svg>
  );
}
function BuildingIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 21h18M5 21V7l7-4 7 4v14M9 21v-4h6v4"/>
    </svg>
  );
}

function Signup() {
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [companyName, setCompanyName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [countryCode, setCountryCode] = useState('91');
    const [errors, setErrors] = useState({});
    const [strength, setStrength] = useState(0);
    const [resMsg, setResMsg] = useState('');
    const [errResMsg, setErrResMsg] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [showPass, setShowPass] = useState(false);
    const [showConfirmPass, setShowConfirmPass] = useState(false);
    const [termsServiceModal, setTermsServiceModal] = useState(false);
    const [privacyPolicyModal, setPrivacyPolicyModal] = useState(false);

    const location = useLocation();
    const navigate = useNavigate();

    const { sso } = useSsoDiscovery(email);
    const ssoBlocked = sso.ssoEnabled;

    const validate = () => {
        const newErrors = {};
        const emailRegex = /^(?![.\-])[A-Za-z0-9._%-]+(?<![.\-])@[A-Za-z0-9]+(?:-[A-Za-z0-9]+)*(?:\.[A-Za-z]{2,})+$/;
        const passwordRegex = /^(?=.{8,}$)(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()]).*$/;
        const nameRegex = /^(?!\s+$)[A-Za-z\s]+$/;;
        if (!firstName) {
            newErrors.firstName = 'First name is required.';
            setIsLoading(false);
        } else if (!nameRegex.test(firstName)) {
            newErrors.firstName = 'Name should contain only alphabets.';
            setIsLoading(false);
        }
        if (!lastName) {
            newErrors.lastName = 'Last name is required.';
            setIsLoading(false);
        } else if (!nameRegex.test(lastName)) {
            newErrors.lastName = 'Last Name should contain only alphabets.';
            setIsLoading(false);
        }
        if (!companyName) {
            newErrors.companyName = 'Company name is required.';
            setIsLoading(false);
        }
        if (!email) {
            newErrors.email = 'Email is required.';
            setIsLoading(false);
        } else if (!emailRegex.test(email)) {
            newErrors.email = 'Enter a valid email.';
            setIsLoading(false);
        }
        if (!phoneNumber || phoneNumber.length < 5) {
            newErrors.phoneNumber = 'Valid phone number is required.';
            setIsLoading(false);
        }
        if (!password) {
            newErrors.password = 'Password is required.';
            setIsLoading(false);
        } else if (!passwordRegex.test(password)) {
            newErrors.password = 'Password must be 8+ chars with uppercase, lowercase, number & special char.';
            setIsLoading(false);
        }
        if (!confirmPassword) {
            newErrors.confirm = 'Please confirm your password.';
            setIsLoading(false);
        } else if (confirmPassword !== password) {
            newErrors.confirm = 'Passwords do not match.';
            setIsLoading(false);
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const onChangeHandler = (e) => {
        const { name, value } = e.target;
        const setters = {
            firstName: setFirstName, lastName: setLastName,
            companyName: setCompanyName, email: setEmail,
            password: setPassword, confirmPassword: setConfirmPassword,
        };
        if (setters[name]) { setters[name](value); setErrResMsg(''); }
        if (name === 'password') { setStrength(calculateStrength(value)); setErrResMsg(''); }
        setErrors({});
    };

    const calculateStrength = (password) => {
        let strength = 0;
        if (password.length >= 10) strength++;
        if (/[a-z]/.test(password)) strength++;
        if (/[A-Z]/.test(password)) strength++;
        if (/\d/.test(password)) strength++;
        if (/[!@#$%^&*()]/.test(password)) strength++;
        return Math.min(strength, 4);
    };

    const submitHandler = async (e) => {
        e.preventDefault();
        if (ssoBlocked) return;
        setIsLoading(true);
        if (!validate()) return;
        try {
            const queryData = {
                emailId: email, otp_type: 'EMAIL_VERIFICATION',
                phone_number: phoneNumber, country_code: countryCode
            };
            const local_data = {
                first_name: firstName, last_name: lastName, company_name: companyName,
                emailId: email, password: password, confirm_password: confirmPassword,
                phone_number: phoneNumber, country_code: countryCode
            };
            const response = await send_otp(queryData);
            setIsLoading(false);
            const successMessage = response?.statusCode?.response_data?.message;
            const errorMessage = response?.errors?.message;
            const errResMsg = response?.error?.message;
            if (successMessage) {
                setResMsg(successMessage);
                setErrResMsg('');
                localStorage.setItem("user_data", JSON.stringify(local_data));
                localStorage.setItem('is_popup_closed', 'false');
                localStorage.setItem('company_name', local_data.company_name);
                sessionStorage.setItem('is_otp_allowed', 'signup');
                navigate('/otp-verification', { state: { from: 'signup' } });
            } else if (errResMsg) {
                setErrResMsg(errResMsg);
                setResMsg('');
            } else if (errorMessage) {
                setErrResMsg(errorMessage);
            }
        } catch (error) {
            setIsLoading(false);
        }
    };


    return (
        <>
            <AuthLayout>
                <AuthLayout.Stage/>
                <AuthLayout.Panel>
                <div className="lg-wrap">
                    <header className="lg-form-header">
                        <p className="lg-eyebrow"><UserIcon/> Create account</p>
                        <h1 className="lg-title" id="lg-su-title">Join Foresee Security</h1>
                        <p className="lg-lead">Enter your company details to get started.</p>
                    </header>

                    {errResMsg && (
                        <div className="lg-alert lg-alert--error" role="alert">
                            <AlertCircleIcon/> <span>{errResMsg}</span>
                        </div>
                    )}
                    {resMsg && (
                        <div className="lg-alert lg-alert--success" role="status">
                            <CheckCircleIcon/> <span>{resMsg}</span>
                        </div>
                    )}
                    {ssoBlocked && (
                        <div className="lg-alert lg-alert--error" role="alert">
                            <AlertCircleIcon/>
                            <span>
                                This organisation already uses SSO.{' '}
                                <button type="button" className="lg-link" onClick={() => navigate('/')}>Log in directly.</button>
                            </span>
                        </div>
                    )}

                    <form className="lg-form" noValidate onSubmit={submitHandler}>
                        <div className="lg-form-row">
                            <Field name="firstName" type="text" label="First name" icon={<UserIcon/>}
                                value={firstName} onChange={onChangeHandler} error={errors.firstName} autoComplete="given-name"/>
                            <Field name="lastName" type="text" label="Last name" icon={<UserIcon/>}
                                value={lastName} onChange={onChangeHandler} error={errors.lastName} autoComplete="family-name"/>
                        </div>

                        <Field name="companyName" type="text" label="Company name" icon={<BuildingIcon/>}
                            value={companyName} onChange={onChangeHandler} error={errors.companyName} autoComplete="organization"/>

                        <Field name="email" type="email" label="Work email" icon={<MailIcon/>}
                            value={email} onChange={onChangeHandler} error={errors.email} autoComplete="email"/>

                        <div className="lg-field">
                            <label className="lg-phone-label">Phone number</label>
                            <div className={`lg-phone-wrap${errors.phoneNumber ? ' lg-phone-wrap--invalid' : ''}`}>
                                <PhoneInput
                                    country={'in'}
                                    enableSearch={true}
                                    value={countryCode + phoneNumber}
                                    onChange={(phone, country) => {
                                        setCountryCode(country.dialCode);
                                        setPhoneNumber(phone.slice(country.dialCode.length));
                                        setErrors(prev => ({ ...prev, phoneNumber: '' }));
                                    }}
                                    inputProps={{ name: 'phone', required: true, autoFocus: false }}
                                    containerClass="lg-pi"
                                    inputClass="lg-pi-input"
                                    buttonClass="lg-pi-btn"
                                    dropdownClass="lg-pi-dropdown"
                                    searchClass="lg-pi-search"
                                />
                            </div>
                            {errors.phoneNumber && (
                                <p className="lg-field-error" role="alert">
                                    <AlertCircleIcon/> {errors.phoneNumber}
                                </p>
                            )}
                        </div>

                        <Field name="password" type={showPass ? 'text' : 'password'} label="Password" icon={<LockIcon/>}
                            value={password} onChange={onChangeHandler} error={errors.password} autoComplete="new-password"
                            trailing={<EyeButton visible={showPass} onToggle={() => setShowPass(s => !s)}/>}/>

                        <div className="lg-strength-wrap" data-s={strength}>
                            <div className="lg-strength" data-s={strength}>
                                {Array.from({ length: 4 }).map((_, idx) => (
                                    <div key={idx} className={`lg-str-bar${idx < strength ? ' lg-str-bar--on' : ''}`}/>
                                ))}
                            </div>
                            <span className="lg-strength-label">
                                {['', 'Weak', 'Fair', 'Good', 'Strong'][strength] || ''}
                            </span>
                        </div>

                        <Field name="confirmPassword" type={showConfirmPass ? 'text' : 'password'} label="Confirm password" icon={<LockIcon/>}
                            value={confirmPassword} onChange={onChangeHandler} error={errors.confirm} autoComplete="new-password"
                            trailing={<EyeButton visible={showConfirmPass} onToggle={() => setShowConfirmPass(s => !s)}/>}/>

                        <button type="submit" className="lg-submit lg-spot"
                            disabled={isLoading || ssoBlocked} aria-busy={isLoading} onPointerMove={trackPointer}>
                            {isLoading ? (
                                <span className="lg-submit-label"><span className="lg-spin" aria-hidden="true"/> Creating account...</span>
                            ) : (
                                <span className="lg-submit-label">Create account <ArrowRightIcon/></span>
                            )}
                            {isLoading && <i className="lg-scan" aria-hidden="true"/>}
                        </button>
                    </form>

                    <p className="lg-signup">
                        Already have an account?{' '}
                        <button type="button" className="lg-link" onClick={() => navigate('/')}>Log in</button>
                    </p>
                </div>

                <p className="lg-trust">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <rect x="4.5" y="10.5" width="15" height="10" rx="3"/>
                        <path d="M8 10.5V8a4 4 0 018 0v2.5"/>
                    </svg>
                    By signing up you agree to our{' '}
                    <button type="button" className="lg-link" onClick={() => setTermsServiceModal(true)}>Terms of Service</button>
                    {' '}and{' '}
                    <button type="button" className="lg-link" onClick={() => setPrivacyPolicyModal(true)}>Privacy Policy</button>.
                </p>
                </AuthLayout.Panel>
            </AuthLayout>

            {termsServiceModal && <TermsService show={termsServiceModal} onHide={() => setTermsServiceModal(false)}/>}
            {privacyPolicyModal && <PrivacyPolicy show={privacyPolicyModal} onHide={() => setPrivacyPolicyModal(false)}/>}
        </>
    );
}

export default Signup;
